<template>
    <div class="c-filter-select c-filter-select--kd">

        <select :aria-label="filterType.label" :name="filterType.key" v-model="selectedFilters">
            <option :aria-label="filterType.label" value="" selected>{{ filterType.label }}</option>
            <option :aria-label="term.label" v-for="term in filterType.terms" :value="term.slug">
                {{ term.label }}
            </option>
        </select>

        <button v-if="selectedFilterTermLabel" @click="selectedFilters = ''">{{ selectedFilterTermLabel }}</button>

    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    filterType: Object,
});

const selectedFilters = defineModel('selectedFilters');

const selectedFilterTermLabel = computed(() => {
    const sel = selectedFilters.value || '';
    const term = (props.filterType.terms || []).find(t => t.slug === sel);
    return term ? term.label : '';
});
</script>

<style scoped></style>
